<iq-central-front-end-navbar></iq-central-front-end-navbar>
<section class="course-details">
  <header class="course-header">
    <div class="container">
      <div class="row pt-5">
        <div class="col-lg-6 col-sm-12 mb-2">
          <span class="font20 click my-5 text-white" routerLink="/courses">
            <i class="fa fa-arrow-left mr-3"></i> {{ courseData?.title }}
          </span>
        </div>
        <div class="col-lg-6 col-sm-12" *rbacAllow="[true]">
          <div class="d-flex justify-content-end">
            <button
              [disabled]="courseData?.isActive === false"
              [matTooltip]="
                courseData?.isActive === false
                  ? 'You cannot assign an inactive course'
                  : 'Assign this course'
              "
              class="btn btn-outline-secondary btn-sm my-5 mr-3"
              [routerLink]="[
                '/assignCourse/selectParticipant',
                { code: courseCode }
              ]"
            >
              Assign to ..
            </button>
            <button
              class="btn btn-outline-secondary btn-sm my-5 mr-3"
              (click)="delete()"
            >
              Delete
            </button>
            <button
              class="btn btn-secondary btn-sm my-5"
              [routerLink]="['/courses/edit-course', courseCode]"
            >
              Edit Course
            </button>
          </div>
        </div>
      </div>
      <div class="row pb-4">
        <div
          class="col-lg-8 col-sm-12 my-auto course"
          *ngIf="content?.contentType == null"
        >
          <img src="{{ courseData?.imageUrl }}" alt="" class="w-100" />
        </div>

        <div
          class="col-lg-8 col-sm-12 my-auto"
          *ngIf="content?.contentType === 'QUIZ'"
        >
          <img src="{{ courseData?.imageUrl }}" alt="" class="w-100" />
        </div>
        <div
          class="col-lg-8 col-sm-12 my-auto"
          *ngIf="content?.contentType === 'video'"
        >
          <video
            [src]="filePath"
            width="100%"
            height=""
            controls
            autoplay
          ></video>
        </div>
        <div
          class="col-lg-8 col-sm-12 my-auto"
          *ngIf="content?.contentType === 'pdf'"
        >
          <ngx-extended-pdf-viewer
            [src]="filePath"
            [textLayer]="true"
            [showHandToolButton]="true"
            [showDownloadButton]="true"
            height="600px"
            [locale]="'en-GB'"
          >
          </ngx-extended-pdf-viewer>
        </div>

        <div class="col-lg-4 col-sm-12 sm-mt myAccordion" *rbacAllow="[true]">
          <div class="lesson-playlist">
            <div
              class="p-3 justify-content-between d-flex playlist-header text-white"
            >
              <span>{{ courseData?.lessons?.length }} Module(s)</span>
              <span class="font12">
                {{ duration }}
              </span>
            </div>
            <div id="accordion">
              <div class="card" *ngFor="let lesson of lessons; index as i">
                <div class="card-header" [attr.id]="'headerOne' + i">
                  <a
                    data-toggle="collapse"
                    [attr.href]="'#collapseOne' + i"
                    aria-expanded="true"
                    [attr.aria-controls]="'collapseOne' + i"
                  >
                    <div class="d-flex justify-content-start">
                      <span>
                        Module {{ i + 1 }}:
                        {{
                          lesson?.title?.length > 20
                            ? (lesson.title | slice : 0 : 20) + '...'
                            : lesson.title
                        }}
                      </span>
                    </div>
                  </a>
                </div>
                <div
                  [attr.id]="'collapseOne' + i"
                  class="collapse"
                  [attr.aria-labelledby]="'headingOne' + i"
                  [attr.data-parent]="'#accordion'"
                  *ngFor="let content of lesson?.lessonContents; index as j"
                >
                  <div class="card-body">
                    <table class="table no-wrap">
                      <tbody>
                        <td
                          class="click"
                          (click)="setFilePathAndTypeAdmin(content)"
                        >
                          <div class="d-flex justify-content-between">
                            <p class="font14 mb-0">
                              <i
                                class="fa fa-video-camera mr-2"
                                *ngIf="content?.contentType === 'video'"
                              ></i>
                              <i
                                class="fa fa-list-ol mr-2"
                                *ngIf="content?.contentType === 'QUIZ'"
                              ></i>
                              <i
                                class="fa fa-file-pdf-o mr-2"
                                *ngIf="content?.contentType === 'pdf'"
                              ></i>
                              {{ content?.name }}
                            </p>
                            <p
                              class="font14 mb-0"
                              *ngIf="content?.contentType === 'video'"
                            >
                              {{ content?.lessonContentVideo?.duration }}
                              seconds
                            </p>
                            <p
                              class="font14 mb-0"
                              *ngIf="content?.contentType === 'pdf'"
                            >
                              {{ content?.lessonContentPdf?.minutesRead }}
                              seconds read
                            </p>
                          </div>
                        </td>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-sm-12 sm-mt" *rbacAllow="[false]">
          <div class="lesson-plylist">
            <div
              class="p-3 justify-content-between align-items-center d-flex playlist-header"
            >
              <span>{{ courseData.lessons.length }} Lessons</span>
              <span class="font12">
                {{ duration }}
              </span>
            </div>
            <div class="myAccordion">
              <div id="accordion">
                <div
                  class="card"
                  *ngFor="let lesson of courseData.lessons; index as i"
                >
                  <div class="card-header" [attr.id]="'headerOne' + i">
                    <a
                      data-toggle="collapse"
                      [attr.href]="'#collapseOne' + i"
                      aria-expanded="true"
                      [attr.aria-controls]="'collapseOne' + i"
                    >
                      <div class="d-flex justify-content-start">
                        <span [ngClass]="{ clickable: i == 0 }">
                          Lesson {{ i + 1 }}:
                          {{ (lesson?.title | slice : 0 : 20) + '...' }}
                        </span>
                      </div>
                    </a>
                  </div>
                  <div
                    [attr.id]="'collapseOne' + i"
                    class="collapse"
                    [attr.aria-labelledby]="'headingOne' + i"
                    [attr.data-parent]="'#accordion'"
                    *ngFor="let content of lesson?.lessonContents; index as j"
                  >
                    <div class="card-body">
                      <table class="table no-wrap">
                        <tbody>
                          <td
                            class="click enrolled"
                            (click)="setFilePathAndTypeStaff(content)"
                            *ngIf="isEnrolled"
                          >
                            <div class="d-flex justify-content-between">
                              <p class="font14 mb-0">
                                <i
                                  class="fa fa-video-camera mr-2"
                                  *ngIf="content?.contentType === 'video'"
                                ></i>
                                <i
                                  class="fa fa-list-ol mr-2"
                                  *ngIf="content?.contentType === 'QUIZ'"
                                ></i>
                                <i
                                  class="fa fa-file-pdf-o mr-2"
                                  *ngIf="content?.contentType === 'pdf'"
                                ></i>
                                {{ (content?.name | slice : 0 : 20) + '...' }}
                              </p>
                              <p
                                class="font14 mb-0"
                                *ngIf="content?.contentType === 'video'"
                              >
                                {{ content?.lessonContentVideo?.duration }}
                                seconds
                              </p>
                              <p
                                class="font14 mb-0"
                                *ngIf="content?.contentType === 'pdf'"
                              >
                                {{ content?.lessonContentPdf?.minutesRead }}
                                seconds read
                              </p>
                              <p class="font20 mb-0 text-green">
                                <i
                                  class="fa fa-check-circle"
                                  *ngIf="
                                    courseData.watchedContents.includes(
                                      content.id
                                    )
                                  "
                                ></i>
                              </p>
                            </div>
                          </td>

                          <td
                            class="click notEnrolled"
                            *ngIf="!isEnrolled"
                            (click)="
                              i == 0 && j == 0
                                ? setFilePathAndTypeStaff(content)
                                : false
                            "
                          >
                            <div class="d-flex justify-content-between">
                              <p
                                class="font14 mb-0"
                                [ngClass]="{
                                  clickable: i == 0 && j == 0
                                }"
                              >
                                <i
                                  class="fa fa-video-camera mr-2"
                                  *ngIf="content?.contentType === 'video'"
                                ></i>
                                <i
                                  class="fa fa-list-ol mr-2"
                                  *ngIf="content?.contentType === 'QUIZ'"
                                ></i>
                                <i
                                  class="fa fa-file-pdf-o mr-2"
                                  *ngIf="content?.contentType === 'pdf'"
                                ></i>
                                {{ content?.name }}
                              </p>
                              <p
                                class="font14 mb-0"
                                [ngClass]="{
                                  clickable: i == 0 && j == 0
                                }"
                                *ngIf="content?.contentType === 'video'"
                              >
                                {{ content?.lessonContentVideo?.duration }}
                                seconds
                              </p>
                              <p
                                class="font14 mb-0"
                                [ngClass]="{
                                  clickable: i == 0 && j == 0
                                }"
                                *ngIf="content?.contentType === 'pdf'"
                              >
                                {{ content?.lessonContentPdf?.minutesRead }}
                                seconds read
                              </p>
                            </div>
                          </td>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="!isEnrolled">
            <button class="btn btn-enroll" (click)="enroll()">Enroll</button>
          </div>
        </div>
      </div>
    </div>
  </header>
  <div class="bg-white">
    <div class="container">
      <div class="row py-3">
        <div class="col-lg-8 col-sm-12">
          <ul class="nav nav-pills" id="pills-tab" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link active"
                id="pills-Overview-tab"
                data-toggle="pill"
                href="#pills-Overview"
                role="tab"
                aria-controls="pills-Overview"
                aria-selected="true"
                >Overview</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="pills-Comments-tab"
                data-toggle="pill"
                href="#pills-Comments"
                role="tab"
                aria-controls="pills-Comments"
                aria-selected="false"
                (click)="getComments()"
                >Comments</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="pills-Reviews-tab"
                data-toggle="pill"
                href="#pills-Reviews"
                role="tab"
                aria-controls="pills-Reviews"
                aria-selected="false"
                >Reviews</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="pills-Results-tab"
                data-toggle="pill"
                href="#pills-Results"
                role="tab"
                aria-controls="pills-Results"
                aria-selected="false"
                >Results</a
              >
            </li>
          </ul>
        </div>
        <div class="col-lg-4 col-sm-12 sm-mt">
          <span class="dropdown px-3">
            <span
              class=""
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="fa fa-share-alt mr-2"></i>Share
              <i class="fa fa-angle-down"></i>
            </span>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <a
                class="dropdown-item py-1"
                href="{{ facebookUrl }}"
                onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');return false;"
                target="_blank"
                title="Share on Facebook"
              >
                <img src="assets/icons/fb.svg" alt="" width="17" /> Facebook
              </a>
              <a
                class="dropdown-item py-1"
                [href]="whatsappUrl"
                data-action="share/whatsapp/share"
                onClick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');return false;"
                target="_blank"
                title="Share on whatsapp"
              >
                <img src="assets/icons/whatsapp.svg" alt="" width="17" />
                Whatsapp
              </a>
              <a
                class="dropdown-item py-1"
                href="{{ twitterUrl }}"
                onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');return false;"
                target="_blank"
                title="Share on Twitter"
              >
                <img src="assets/icons/twitter.svg" alt="" width="17" /> Twitter
              </a>
              <a
                class="dropdown-item py-1"
                href="{{ linkedInUrl }}"
                onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');return false;"
                target="_blank"
                title="Share on Linkedin"
              >
                <img src="assets/icons/linkedin.svg" alt="" width="17" />
                Linkedin
              </a>
              <a
                class="dropdown-item py-1"
                href="{{ emailUrl }}"
                onClick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');return false;"
                target="_blank"
                title="Share on Mail"
              >
                <img src="assets/icons/email.svg" alt="" width="17" /> Email
              </a>
            </div>
          </span>
          <span class="font14">
            <input
              type="checkbox"
              (change)="likeDislikeCourse($event, courseData)"
              id="checkbox"
              hidden
            />
            <label class="ml-auto click" for="checkbox">
              <!-- <span
                class="save font30 click"
                [class]="course.isSaved ? 'like' : 'dislike'"
                >❤</span
              > -->
              <i
                [class]="
                  courseData.isLiked ? 'fa fa-thumbs-up' : 'fa fa-thumbs-down'
                "
              ></i>
              Recommend
              <!-- <i class="fa fa-thumbs-down mr-2"></i> Recommend -->
            </label>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row py-5">
      <div class="col-lg-8 col-sm-12">
        <div class="tab-content" id="pills-tabContent">
          <div
            class="tab-pane fade show active"
            id="pills-Overview"
            role="tabpanel"
            aria-labelledby="pills-Overview-tab"
          >
            <div>
              <p class="font14 font-light" [innerHTML]="description"></p>
            </div>
          </div>

          <div
            class="tab-pane fade"
            id="pills-Reviews"
            role="tabpanel"
            aria-labelledby="pills-Reviews-tab"
          >
            <div class="my-4 row">
              <div class="col-lg-8 col-sm-12">
                <div class="bg-white py-3 px-4" style="min-height: 246px">
                  <div class="text-center mb-3 font-bold">
                    Did this course meet your expectations?
                  </div>
                  <div class="my-2 font14 row align-items-center">
                    <div class="col-2">Exceeded</div>
                    <div class="col-8">
                      <div class="progress">
                        <div
                          class="progress-bar"
                          role="progressbar"
                          aria-valuenow="70"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          [style.width]="expectations[4] + '%'"
                        ></div>
                      </div>
                    </div>
                    <div class="col-2">
                      {{ expectations[4] | number : '1.0-0' }}%
                    </div>
                  </div>
                  <div class="my-2 font14 row align-items-center">
                    <div class="col-2">Yes</div>
                    <div class="col-8">
                      <div class="progress">
                        <div
                          class="progress-bar"
                          role="progressbar"
                          aria-valuenow="70"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          [style.width]="expectations[3] + '%'"
                        ></div>
                      </div>
                    </div>
                    <div class="col-2">
                      {{ expectations[3] | number : '1.0-0' }}%
                    </div>
                  </div>
                  <div class="my-2 font14 row align-items-center">
                    <div class="col-2">Somewhat</div>
                    <div class="col-8">
                      <div class="progress">
                        <div
                          class="progress-bar"
                          role="progressbar"
                          aria-valuenow="70"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          [style.width]="expectations[2] + '%'"
                        ></div>
                      </div>
                    </div>
                    <div class="col-2">
                      {{ expectations[2] | number : '1.0-0' }}%
                    </div>
                  </div>
                  <div class="my-2 font14 row align-items-center">
                    <div class="col-2">Not Really</div>
                    <div class="col-8">
                      <div class="progress">
                        <div
                          class="progress-bar"
                          role="progressbar"
                          aria-valuenow="70"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          [style.width]="expectations[1] + '%'"
                        ></div>
                      </div>
                    </div>
                    <div class="col-2">
                      {{ expectations[1] | number : '1.0-0' }}%
                    </div>
                  </div>
                  <div class="my-2 font14 row align-items-center">
                    <div class="col-2">No</div>
                    <div class="col-8">
                      <div class="progress">
                        <div
                          class="progress-bar"
                          role="progressbar"
                          aria-valuenow="70"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          [style.width]="expectations[0] + '%'"
                        ></div>
                      </div>
                    </div>
                    <div class="col-2">
                      {{ expectations[0] | number : '1.0-0' }}%
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-sm-12 sm-mt">
                <div class="bg-white py-3 px-4" style="min-height: 246px">
                  <div class="text-center mb-3">Interaction</div>
                  <p class="font14">
                    <i class="fa fa-thumbs-up mr-3"></i>
                    {{ courseData.totalLikes }} Recommended
                  </p>
                  <p class="font14">
                    <i class="fa fa-star mr-3"></i>
                    {{ courseData?.courseRatings?.length }} Rating(s)
                  </p>
                  <p class="font14">
                    <i class="fa fa-share-alt mr-3"></i>
                    865 Shares
                  </p>
                </div>
              </div>
            </div>
            <button
              *rbacAllow="[false]"
              class="btn btn-sm mb-3"
              class="btn btn-secondary btn-sm blue"
              data-toggle="modal"
              data-target="#rateModal"
            >
              Leave Review
            </button>

            <div class="card-table table-responsive">
              <table class="table no-wrap" id="myTable">
                <tbody>
                  <tr
                    class="my-3"
                    *ngFor="let review of courseData.courseRatings"
                  >
                    <td class="mx-3 no-wrap">
                      <div class="d-flex align-items-center">
                        <div class="mr-3">
                          <img
                            src="{{
                              review.enterpriseUser.user.avatarUrl
                                ? review.enterpriseUser.user.avatarUrl
                                : 'assets/images/avatar.jpg'
                            }}"
                            alt=""
                            width="50"
                            height="50"
                            class="rounded-circle"
                          />
                        </div>
                        <div>
                          <p class="mb-1 font14">
                            {{ review.enterpriseUser.user.fullName }}
                          </p>
                          <p class="mb-0 font12 text-grey">
                            {{ review.createdAt | date }}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="font-light">
                        This class
                        <span class="font-bold">{{ review.message }}</span>
                      </div>
                    </td>
                    <td>
                      <div
                        class="rating   {{ transformRating(review?.rating) }}"
                      >
                        <span>☆</span><span>☆</span><span>☆</span><span>☆</span
                        ><span>☆</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="pills-Comments"
            role="tabpanel"
            aria-labelledby="pills-Comments-tab"
          >
            <div class="row m-2 py-3 commentTable">
              <div
                class="my-2 col-md-12 col-sm-12 text-black"
                *ngFor="let comment of comments | slice : 0 : 3; index as i"
              >
                <div class="comCon p-2">
                  <div class="d-flex align-items-center">
                    <div class="mr-2">
                      <img
                        src="{{
                          comment.enterpriseUser.user.avatarUrl
                            ? comment.enterpriseUser.user.avatarUrl
                            : 'assets/images/avatar.jpg'
                        }}"
                        alt=""
                        class="imgCom rounded-circle"
                        height="50"
                        width="50"
                      />
                    </div>
                    <div class="pl-2">
                      <p class="mb-1 font18 text-dark font-bold">
                        {{ comment.enterpriseUser.user.fullName }}
                      </p>
                      <span class="font10 text-grey font-light">
                        {{ comment.enterpriseUser.designation.name }} at
                        {{ comment.enterpriseUser.company.name }}
                      </span>
                    </div>
                  </div>
                  <p class="pl-5 ml-3 my-2 font16 text-gray font-light">
                    {{ comment.message }}
                  </p>
                </div>

                <div [formGroup]="replyForm" class="m-2">
                  <i class="fa fa-mail-reply text-green"></i>
                  <input
                    class="smInput border-bottom-1 px-2"
                    formControlName="message"
                    type="text"
                    placeholder="Leave a Reply"
                    [ngClass]="{
                      'is-invalid':
                        commentForm.get('message').errors &&
                        commentForm.get('message').touched
                    }"
                  />

                  <span>
                    <button
                      class="btn btn-secondary text-white repbtn"
                      (click)="replyComments(comment.id, i)"
                    >
                      Send
                    </button>
                  </span>
                </div>

                <div
                  class="dropdown show m-2"
                  *ngIf="comment.replies.length >= 1"
                >
                  <a
                    class="dropdown-toggle text-green font-bold m-2"
                    href="replyTog"
                    role="button"
                    id="dropdownMenuLink"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Replies
                  </a>

                  <div
                    style="width: 80%"
                    class="ml-5 dropdown-menu p-0 m-0"
                    aria-labelledby="dropdownMenuLink"
                  >
                    <div class="col-md-12 p-0 m-0 bg-grey replyH" id="replyTog">
                      <div
                        class="bg-dark-grey p-3 mb-1 mx-0 md-col-12 d-flex row"
                        *ngFor="let reply of comment.replies"
                      >
                        <div class="col-md-2 px-2 d-flex">
                          <div class="mr-2">
                            <img
                              src="{{
                                reply.enterpriseUser.user.avatarUrl
                                  ? reply.enterpriseUser.user.avatarUrl
                                  : 'assets/images/avatar.jpg'
                              }}"
                              alt=""
                              class="imgCom"
                            />
                          </div>
                        </div>
                        <div class="col-md-10 align-content-start">
                          <div class="align-items-start font-bold">
                            <div class="mt-1 font14 font-bold">
                              {{ reply.enterpriseUser.user.fullName }}
                            </div>
                            <span class="my-0 font10 font-light">
                              | {{ reply.enterpriseUser.designation.name }} at
                              {{ reply.enterpriseUser.company.name }}
                            </span>
                          </div>

                          <div
                            class="mx-1 my-2 font14 font-light d-flex align-content-start"
                          >
                            {{ reply.message }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <hr />
                    </div>
                  </div>
                </div>
              </div>

              <button
                *rbacAllow="[false]"
                class="btn btn-secondary mx-3 my-5 btn-sm blue"
                data-toggle="modal"
                data-target="#commentModal"
              >
                Leave Comment
              </button>
              <div
                class="d-flex justify-content-center sm-flex-column"
                *ngIf="comments['comments'] === 0"
              >
                <pagination-controls
                  id="listing_pagination"
                  (pageChange)="navigatePage($event)"
                ></pagination-controls>
              </div>
            </div>
          </div>

          <div
            class="tab-pane fade"
            id="pills-Results"
            role="tabpanel"
            aria-labelledby="pills-Results-tab"
          >
            <div class="list-view__wrapper table-responsive">
              <div class="rc-title__wrapper">
                <button class="btn btn-secondary btn-sm ml-4">
                  Generate Report
                </button>
              </div>
              <table class="table no-wrap" id="myTable">
                <tbody>
                  <tr class="my-5" *ngFor="let review of reviews">
                    <td>
                      <div class="mx-2 d-flex align-items-center">
                        <div class="profile">
                          <img src="assets/images/avatar.jpg" alt="" />
                        </div>
                        <div class="mx-2">Serenity Pena</div>
                      </div>
                    </td>
                    <td class="mx-3 no-wrap">
                      <div
                        class="mx-2 d-flex justify-content-around align-items-center"
                      >
                        <div>
                          <h5 class="header mb-0">DATE</h5>
                          <p class="value mb-0 mt-1">Dec 7, 2019</p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div
                        class="mx-2 d-flex justify-content-around align-items-center"
                      >
                        <div class="mx-2">
                          <p class="header mb-0">ATTEMPTS</p>
                          <p class="value mb-0 mt-1">25</p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="mx-2">
                        <div class="font24">59%</div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-sm-12">
        <div class="row font-bold">
          <div class="col-4 mt-4">
            <p class="text-grey font12 mb-1">LAST UPDATE</p>
            <p class="font14">{{ courseData?.updatedAt | date }}</p>
          </div>
          <div class="col-4 mt-4">
            <p class="text-grey font12 mb-1">CERTIFICATION</p>
            <div *rbacAllow="[true]">
              <p
                class="text-green font14 click"
                (click)="openCertificate()"
                *ngIf="courseData?.hasCertificate"
              >
                View
              </p>
              <p class="text-green font14" *ngIf="!courseData?.hasCertificate">
                No Certificate
              </p>
            </div>
            <div *rbacAllow="[false]">
              <!-- <p class=" text-green font14 click" (click)="openCertificate()">
                    View
                </p> -->
              <p class="text-green font14" *ngIf="!courseData?.hasCertificate">
                No Certificate
              </p>
              <p class="text-green font14" *ngIf="courseData?.hasCertificate">
                Yes
              </p>
            </div>
          </div>
          <div class="col-4 mt-4">
            <p class="text-grey font12 mb-1">LEVEL</p>
            <p class="font14">{{ courseData?.level }}</p>
          </div>
          <div class="col-4 mt-4">
            <p class="text-grey font12 mb-1">STUDENTS</p>
            <p class="font14">{{ courseData?.enrolledUsers?.length }}</p>
          </div>
          <!-- <div class="col-4 mt-4">
            <p class="text-grey font12 mb-1">PROJECTS</p>
            <p class="font14">709</p>
          </div> -->
          <div class="col-4 mt-4">
            <p class="text-grey font12 mb-1">COMMENTS</p>
            <p class="font14">{{ commentLength }}</p>
          </div>
        </div>
        <hr />
        <div class="d-flex py-4 align-items-center">
          <div>
            <img
              src="{{
                courseData?.contentprovider?.user?.avatarUrl
                  ? courseData?.contentprovider?.user?.avatarUrl
                  : 'assets/images/avatar.jpg'
              }}"
              alt=""
              class="mr-3 profile-img rounded-circle"
            />
          </div>
          <div>
            <p class="mb-1">
              {{ courseData?.contentProvider?.user?.fullName }}
            </p>
            <p class="font12 text-grey font-light">
              Visual Animator, Lecturer at Havard
            </p>
            <button
              class="btn btn-secondary btn-sm"
              routerLink="/setting/profile"
            >
              View Profile
            </button>
          </div>
        </div>
        <hr />
        <div class="my-4">
          <button
            class="btn-secondary btn-sm my-2 mx-1"
            *ngFor="let tag of courseData?.contentProvider?.subjectAreas"
          >
            {{ tag.name }}
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="footer-wrapper mt-5 container">
  <hr />
  <iq-central-front-end-footer></iq-central-front-end-footer>
</div>

<!-- delete Modal -->
<div
  class="modal fade"
  id="deleteModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="deleteModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="d-flex justify-content-between p-4">
        <h5 class="modal-title" id="deleteModalLabel">Confirm Delete</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p class="font-light px-5">
          Are you sure you want to delete this Course? Click the ‘No’ button to
          cancel this action
        </p>
      </div>
      <div class="modal-footer d-flex justify-content-center">
        <button
          type="button"
          class="btn btn-secondary bg-white btn-outline-secondary"
          data-dismiss="modal"
        >
          No
        </button>
        <button type="button" class="btn btn-primary">Yes</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div
  class="modal fade"
  id="assignModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="assignModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="assignModalLabel">Assign to ..</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="nav-card bg-white px-4 py-3">
          <ul class="nav nav-pills" id="pills-tab" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link active"
                id="Individuals-tab"
                data-toggle="pill"
                href="#Individuals"
                role="tab"
                aria-controls="Individuals"
                aria-selected="true"
                >Individuals</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="Groups-tab"
                data-toggle="pill"
                href="#Groups"
                role="tab"
                aria-controls="Groups"
                aria-selected="false"
                >Groups</a
              >
            </li>
          </ul>
        </div>

        <div class="tab-content" id="pills-tabContent">
          <div
            class="tab-pane fade show active"
            id="Individuals"
            role="tabpanel"
            aria-labelledby="Individuals-tab"
          >
            <div class="bg-white px-4 pt-1">
              <div
                class="row align-items-center sm-reverse table-search-container"
              >
                <div
                  class="text-green font12 font-bold col-lg-2 col-sm-12 sm-text-center sm-mt sm-mb-2"
                >
                  ADD FILTER
                </div>
                <div class="table-search col-lg-7 col-sm-12">
                  <input type="text" placeholder="Search" />
                </div>
                <div
                  class="sort col-lg-3 col-sm-12 sm-mt sm-mb-2 sm-text-center"
                >
                  <span class="font-bold font14 text-grey mr-3">SORT BY</span>
                  <span class="dropdown click">
                    <span
                      class="font-bold text-green font12 dropdown-toggle"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      >Name <i class="fa fa-chevron-down"></i
                    ></span>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a class="dropdown-item click line-under">Name</a>
                      <a class="dropdown-item click">Class</a>
                      <a class="dropdown-item click">State</a>
                    </div>
                  </span>
                </div>
              </div>
              <div class="py-4">
                <div class="row">
                  <div
                    class="col-lg-6 col-sm-12 my-3"
                    *ngFor="let list of lists"
                  >
                    <div
                      class="bg-grey p-4 d-flex justify-content-between align-items-center border-radius"
                    >
                      <div class="d-flex align-items-center">
                        <div class="profile mr-3">
                          <img src="assets/images/avatar.jpg" alt="" />
                        </div>
                        <div>
                          <p class="mb-1 font-bold">Mitchell Fisher</p>
                          <p class="mb-0 text-grey font14">
                            lillie.daniels@example.com
                          </p>
                        </div>
                      </div>
                      <div>
                        <img src="assets/icons/check.png" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <a
                id="Groups-tab"
                data-toggle="pill"
                href="#Groups"
                role="tab"
                aria-controls="Groups"
                aria-selected="false"
              >
                <button class="btn btn-secondary">Continue</button>
              </a>
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="Groups"
            role="tabpanel"
            aria-labelledby="Groups-tab"
          >
            <div class="bg-white pt-1 px-4">
              <div
                class="row align-items-center sm-reverse table-search-container"
              >
                <div
                  class="text-green font12 font-bold col-lg-2 col-sm-12 sm-text-center sm-mt sm-mb-2"
                >
                  ADD FILTER
                </div>
                <div class="table-search col-lg-7 col-sm-12">
                  <input type="text" placeholder="Search" />
                </div>
                <div
                  class="sort col-lg-3 col-sm-12 sm-mt sm-mb-2 sm-text-center"
                >
                  <span class="font-bold font14 text-grey mr-3">SORT BY</span>
                  <span class="dropdown click">
                    <span
                      class="font-bold text-green font12 dropdown-toggle"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      >Name <i class="fa fa-chevron-down"></i
                    ></span>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a class="dropdown-item click line-under">Name</a>
                      <a class="dropdown-item click">Class</a>
                      <a class="dropdown-item click">State</a>
                    </div>
                  </span>
                </div>
              </div>
              <div class="py-4">
                <div class="row">
                  <div
                    class="col-lg-6 col-sm-12 my-3"
                    *ngFor="let list of lists"
                  >
                    <div
                      class="bg-grey p-4 d-flex align-items-center border-radius"
                    >
                      <div class="profile mr-3">
                        <img src="assets/icons/people.png" alt="" />
                      </div>
                      <div>
                        <p class="mb-1 font-bold">Level 1</p>
                        <p class="mb-0 text-grey font14">C-Level Personnel</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-between">
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm"
          data-dismiss="modal"
        >
          Cancel
        </button>
        <button type="button" class="btn btn-secondary btn-sm">Add</button>
      </div>
    </div>
  </div>
</div>

<!-- delete Modal -->
<div
  class="modal fade"
  id="deleteModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="deleteModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="d-flex justify-content-between p-4">
        <h5 class="modal-title" id="deleteModalLabel">Confirm Delete</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p class="font-light px-5">
          Are you sure you want to delete this Course? Click the ‘No’ button to
          cancel this action
        </p>
      </div>
      <div class="modal-footer d-flex justify-content-center">
        <button
          type="button"
          class="btn btn-secondary bg-white btn-outline-secondary"
          data-dismiss="modal"
        >
          No
        </button>
        <button type="button" class="btn btn-primary">Yes</button>
      </div>
    </div>
  </div>
</div>

<!-- rate Modal -->

<div id="rateModal" class="modal fade" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content myModal">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">
          <p class="font26">&times;</p>
        </button>
      </div>
      <div class="modal-body">
        <div class="mBody">
          <p class="font30 mb-3 d-flex justify-content-center">
            Congratulation
          </p>
          <p class="font16 text-grey mb-4 d-flex justify-content-center">
            You have completed the course
          </p>
          <div class="pt-md-4 d-flex justify-content-center">
            <img
              class="img-fluid"
              src="/assets/images/confirmation2.png"
              alt=""
              style="height: 150px"
            />
          </div>
          <p class="font16 text-grey my-4 d-flex justify-content-center">
            How many stars will you give to this course
          </p>
          <form [formGroup]="ratingForm">
            <div class="mb-4 d-flex justify-content-center">
              <bar-rating formControlName="rating" [max]="5">
                <ng-template ratingActive>
                  <i class="fa fa-star" style="margin: 2px; color: #edb867"></i>
                </ng-template>
                <ng-template ratingInactive>
                  <i class="fa fa-star" style="margin: 2px; color: #d2d2d2"></i>
                </ng-template>
              </bar-rating>
            </div>
            <div class="mb-5">
              <input
                class="largeInput"
                formControlName="message"
                type="text"
                placeholder="Leave a comment"
              />
            </div>
          </form>
          <div class="d-flex justify-content-center">
            <button
              class="btn btn-rating"
              (click)="rateCourse()"
              data-dismiss="modal"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Comment Modal -->

<div id="commentModal" class="modal fade" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content myModal">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">
          <p class="font26">&times;</p>
        </button>
      </div>
      <div class="modal-body">
        <div class="mBody">
          <p class="font18 my-3 d-flex justify-content-center">
            How Has Your Course Experience Been?
          </p>

          <div class="pt-md-4 d-flex justify-content-center">
            <img
              class="img-fluid"
              src="/assets/images/confirmation2.png"
              alt=""
              style="height: 150px"
            />
          </div>

          <form [formGroup]="commentForm">
            <div class="my-3">
              <label for="commentText">Leave Comments Here... </label>
              <textarea
                class="form-control p-1"
                id="commentText"
                formControlName="message"
                rows="5"
                [ngClass]="{
                  'is-invalid':
                    commentForm.get('message').errors &&
                    commentForm.get('message').touched
                }"
              >
                                <span class="text-danger">*</span>
                              </textarea
              >
            </div>
          </form>
          <div class="d-flex justify-content-center">
            <button
              class="btn btn-rating"
              (click)="commentCourse()"
              data-dismiss="modal"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
